<template>
  <AwlTable :heading="tableHeadings" :rows="tableRows" striped class="personel-table">
    <template #column-key-ral="{ value }">
      {{ value | money }}
    </template>
    <template #column-key-altriCosti="{ value }">
      {{ value | money }}
    </template>

    <template #column-key-delta="{ value }">
      {{ value }}%
    </template>
    <template #column-key-oneriSociali="{ value }">
      {{ value }}%
    </template>
    <template #column-key-ritenuta="{ value }">
      {{ value }}%
    </template>
    <template #column-key-accantonamentoTfr="{ value }">
      {{ value }}%
    </template>

    <template v-if="editEnabled" #actions-content="{ row }">
      <ActionEdit class="mr-0 mr-md-2" :to="{ name: 'operative-company.data-analysis.personnel.edit', params: { costId: row.id } }" />
      <ActionDelete @click="remove(row.id)" />
    </template>
  </AwlTable>
</template>

<script>

import formatMoneyFilter from '../../../../filters/formatMoney';

export default {
  name: 'costi-list-table',
  components: {
    AwlTable: () => import('../../../../libs/Table/components/AwlTable'),
    ActionDelete: () => import('../../Actions/ActionDelete'),
    ActionEdit: () => import('../../Actions/ActionEdit'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    costi: {
      type: Array,
      default: () => [],
    },
    editEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableHeadings () {
      return [
        { key: 'name', label: 'Categoria' },
        { key: 'nbPeople', label: 'Numero persone' },

        { key: 'begin', label: 'Assunzione' },
        { key: 'end', label: 'Cessazione' },

        { key: 'ral', label: 'RAL' },
        { key: 'mensilita', label: 'Mensilità' },

        { key: 'delta', label: 'Delta' },
        { key: 'ritenuta', label: 'Ritenute fiscali' },
        { key: 'oneriSociali', label: 'Oneri sociali' },
        { key: 'accantonamentoTfr', label: 'Accantonamento TFR' },

        { key: 'altriCosti', label: 'Altri costi' },
      ];
    },
    tableRows () {
      return (this.costi || []).map(r => {
        return r;
      });
    },
  },
  methods: {
    remove (id) {
      if (!this.editEnabled) {
        return;
      }

      this.$emit('delete', id);
    },
  },
};

</script>
